<template>
	<div>
		<stepper
			v-bind:steps="['Account', 'Cause', 'Preferences', 'Funding']"
			:currentStep="1"
		/>
		<screen class="register-view" type="blue">
			<template slot="header">
				<ui-header type="light" @click="onDismiss" action="close">
					<h2 slot="title">Create Account</h2>
				</ui-header>
			</template>

			<div class="register-institution" v-if="institution">
				<div class="institution-image"></div>
				<div class="institution-text">
					Let's get you signed up to give your change to
					<strong>{{ institution.name }}</strong
					>!
				</div>
			</div>
			<form v-on:submit.prevent="onSubmit">
				<label>
					<ui-input
						v-model="user.first_name"
						placeholder="First Name"
						type="blue"
					/>
				</label>
				<label>
					<ui-input
						v-model="user.last_name"
						placeholder="Last Name"
						type="blue"
					/>
				</label>
				<label>
					<p v-if="this.message" v-bind:style="{ color: 'white' }">
						{{ this.message }}
					</p>
					<ui-input
						type="blue"
						v-model="user.phone"
						placeholder="Phone"
						@input="onlyNumber($event)"
					/>
				</label>
				<label>
					<ui-input
						v-model="user.email"
						placeholder="Email"
						type="blue"
					/>
				</label>
				<label>
					<ui-input
						v-model="user.password"
						placeholder="Password"
						native-type="password"
						type="blue"
					/>
				</label>
				<label class="terms">
					<input type="checkbox" v-model="agree" /> I am 13 years or
					older and agree to the
					<a href="https://roundupapp.com/terms" target="_blank"
						>Terms of Use</a
					>
				</label>
				<label>
					<ui-button
						native-type="submit"
						color="white"
						:loading="isLoading"
						>Create Account</ui-button
					>
				</label>
			</form>
			<div @click="login" class="center login" style="color: white">
				Already have an account? Sign In
			</div>
		</screen>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { getUrlParams } from '../../utilities'
import UiButton from '../../ui/Button'
import UiInput from '../../ui/Input'
import UiHeader from '../../ui/Header'
import Stepper from '../../ui/Stepper'
import Screen from '../../ui/Screen'
export default {
	name: 'register-view',
	components: { UiButton, UiInput, UiHeader, Screen, Stepper },
	props: {
		uuid: String
	},
	data() {
		return {
			isLoading: false,
			user: {
				first_name: '',
				last_name: '',
				email: '',
				password: '',
				institution: this.uuid,
				phone: '',
				referred_by: null
			},
			agree: false,
			institution: null,
			message: null
		}
	},
	methods: {
		...mapActions(['register', 'getInstitution']),
		onSubmit() {
			this.isLoading = true
			if (!this.agree) {
				this.$swal(
					'Uh oh!',
					'You must confirm to the terms of use to continue'
				)
				return
			}
			this.register(this.user)
				.then((data) => {
					this.isLoading = false
					if (data.has_institution) {
						this.navigate(
							{
								name: 'mindonation',
								params: { onboarding: true }
							},
							'right'
						)
					} else {
						this.navigate(
							{
								name: 'institutions',
								params: { onboarding: true }
							},
							'right'
						)
					}
				})
				.catch((error) => {
					this.isLoading = false
					this.$swal('Error', error.message)
				})
		},
		onDismiss() {
			this.navigate({ name: 'launch' }, 'down')
		},
		onlyNumber(evt) {
			const clean = evt.replace(/\D+/g, '')
			if (clean !== evt) {
				this.message = 'Numbers only please :)'
			} else {
				this.message = null
			}
			this.user.phone = clean
		},
		login() {
			this.navigate({ name: 'login' }, 'down')
		}
	},
	mounted() {
		this.getInstitution(this.uuid).then((institution) => {
			this.institution = institution
			// if (institution.fb_pixel_code) {
			//     facebook.boot(institution.fb_pixel_code)
			//     facebook.track('PageView')
			// }
		})
		const urlParams = getUrlParams(window.location.href)
		this.user.referred_by = urlParams.referred_by

		if (urlParams) {
			for (var param in urlParams) {
				if (param !== 'email') {
					this.user[param] = decodeURIComponent(urlParams[param])
				}
			}
		}
	}
}
</script>

<style lang="scss">
.register-view {
	.register-institution {
		background: linear-gradient($turqouise, $blue);
		padding: 20px;
		border-radius: 7px;
		color: $white;
		font-weight: 500;
		margin-bottom: 20px;
		text-align: center;
	}
	.terms,
	.terms a {
		color: rgba(255, 255, 255, 0.7);
		font-size: 14px;
	}
	.terms {
		padding: 15px 0;
		input {
			margin-right: 5px;
		}
	}
	.login {
		color: $white;
		opacity: 0.7;
		transition: all 0.25s ease-in-out;
		text-align: center;
		display: block;
		&:hover {
			opacity: 1;
			text-decoration: underline;
			cursor: pointer;
		}
	}
}
</style>
